import { render, staticRenderFns } from "./Sendgrid.vue?vue&type=template&id=76c5015f&scoped=true"
import script from "./Sendgrid.vue?vue&type=script&lang=js"
export * from "./Sendgrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c5015f",
  null
  
)

export default component.exports